<template>
  <div class="column content-box">
    <div class="small-12 columns integrations-wrap">
      <div class="small-12 columns integration">
        <div class="row">
          <div class="small-12 medium-2 integration--image">
            <img :src="'/dashboard/images/integrations/' + integration.logo" />
          </div>
          <div class="small-12 medium-8 column">
            <h3 class="integration--title">
              {{ integration.name }}
            </h3>
            <p v-if="integration.id === 'tekkis'" class="integration--description">
              {{ integration.description }}. Don't have an account? Please sign up
              <a :href="tekkisSignupUrl" target="_blank">here</a>
            </p>
            <p v-else class="integration--description">
              {{ integration.description }}
            </p>
          </div>
          <!-- one moore button for boost  -->
          <div class="small-12 medium-2 column button-wrap">
            <div v-if="integration.id === 'boost'" class="mr_5">
              <div @click="$emit('onClickBoost')">
                <woot-button class="nice primary">
                  {{ $t('INTEGRATION_APPS.EXTRAS.BOOST_BTN') }}
                </woot-button>
              </div>
            </div>
            <div v-if="hasConnectedHooks">
              <div @click="$emit('delete', integration.hooks[0])">
                <woot-button class="nice alert">
                  {{ $t('INTEGRATION_APPS.DISCONNECT.BUTTON_TEXT') }}
                </woot-button>
              </div>
            </div>
            <div v-else>
              <woot-button class="button nice" @click="$emit('add')">
                {{ $t('INTEGRATION_APPS.CONNECT.BUTTON_TEXT') }}
              </woot-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hookMixin from './hookMixin';
export default {
  mixins: [hookMixin],
  props: {
    integration: {
      type: Object,
      default: () => ({}),
    },
  },
  data(){
    return {
      tekkisSignupUrl:'https://tauth.tekkis.com.my/login?ref=LWU1Rsx5cwJo6DhhHPPdXQ4JD9PuCxoLvuy1Jkn5ywhspF4kKcgSGJ2I-7la--sNTn-ailCKKQJW0LQ9Hi1xIWL7DU-zPIcsnBzl',
    }
  },
};
</script>

<style lang="scss" scoped>
.integration--image{
  margin: 0 !important;
}
</style>